<template>
    <v-card class="default_card_wm elevation-0 px-4 py-3 mb-2">
        <v-row no-gutters>
            <v-col cols="12">
                <v-row
                    no-gutters
                    class="d-flex justify-space-between align-center"
                    v-if="!componentForAlreadyDeclaredItems"
                >
                    <v-col cols="1">
                        <v-btn-icon
                            @click="showDataTable = !showDataTable"
                            :icon="showDataTable ? '$fa-chevron-up' : '$fa-chevron-down'"
                        />
                    </v-col>
                    <v-col cols="4">
                        <h4>{{ title }}</h4>
                        <p v-if="fromAutoVATComponent">Calcul au {{ displayableDate }}</p>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="vatItemsSelectedType"
                            :items="vatItemsTypes"
                            item-title="text"
                            item-value="value"
                            label="Filtrer par type"
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="vatItemsSelectedStatus"
                            :items="vatItemsStatus"
                            item-title="text"
                            item-value="value"
                            label="Filtrer par statut"
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" class="d-flex justify-end">
                        <v-btn
                            v-if="filteredVatItems && filteredVatItems.length"
                            rounded
                            @click="vatDeclarationAlreadyDone()"
                            :disabled="disabledVatDeclararionAlreadyDone"
                            size="small"
                        >
                            Déclaration de TVA déjà réalisée
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="showDataTable">
                    <v-data-table
                        :headers="vatItemsHeaders"
                        :items="filteredVatItems"
                        density="compact"
                        :fixed-header="true"
                        color="primary"
                        :itemsPerPage="-1"
                        :hide-default-footer="true"
                        class="table"
                    >
                        <template
                            v-slot:header.checkbox
                            v-if="filteredVatItems.length && !componentForAlreadyDeclaredItems"
                        >
                            <v-checkbox
                                :ripple="false"
                                hide-details
                                @click.stop="selectAllVatItems()"
                                color="primary"
                                :model-value="selectedVatItemIds.length === filteredVatItems.length"
                            />
                        </template>
                        <template v-slot:item="props">
                            <tr :key="props.item.docId">
                                <td>
                                    <v-checkbox
                                        :model-value="
                                            selectedVatItemIds.includes(String(props.item.docId))
                                        "
                                        @click.stop="(e) => selectVatItem(props.item.docId, e)"
                                        color="primary"
                                        hide-details
                                        v-if="!componentForAlreadyDeclaredItems"
                                    />
                                </td>
                                <td @click="props.item.toggleExpand()">
                                    <v-icon color="secondary" class="pl-1">
                                        {{
                                            props.item.isExpanded
                                                ? "$fa-chevron-up"
                                                : "$fa-chevron-down"
                                        }}
                                    </v-icon>
                                </td>
                                <td class="text-truncate" style="max-width: 100px">
                                    <v-icon
                                        v-if="props.item.gotAnomalies"
                                        class="mr-2"
                                        color="red"
                                        v-tooltip="
                                            'Anomalie : Le montant de TVA saisi ne correspond pas au montant calculé automatiquement à partir du montant HT et du taux de TVA.'
                                        "
                                    >
                                        $oss-warning
                                    </v-icon>
                                    <span>{{ props.item.name }}</span>
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        :color="
                                            [
                                                'Collectée',
                                                'Export',
                                                'Non imposable',
                                                'Z de caisse',
                                            ].includes(props.item.vatScheme)
                                                ? 'green'
                                                : 'primary'
                                        "
                                        size="small"
                                        variant="outlined"
                                    >
                                        {{ props.item.vatScheme }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    {{ props.item.documentDate }}
                                </td>
                                <td class="text-center">
                                    {{
                                        props.item.vatScheme === "Import"
                                            ? newCommonFormatCurrency(
                                                  -props.item.grossAmountAls[0].amountSigned,
                                                  undefined,
                                              )
                                            : ["Acquisition intracom", "Autoliquidation"].includes(
                                                    props.item.vatScheme,
                                                )
                                              ? newCommonFormatCurrency(
                                                    Math.abs(props.item.totalGrossAmountSigned),
                                                    undefined,
                                                )
                                              : ["Déductible", "Immobilisation"].includes(
                                                      props.item.vatScheme,
                                                  )
                                                ? newCommonFormatCurrency(0, undefined)
                                                : newCommonFormatCurrency(
                                                      -props.item.totalNetToDeclare,
                                                      undefined,
                                                  )
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        [
                                            "Import",
                                            "Acquisition intracom",
                                            "Autoliquidation",
                                        ].includes(props.item.vatScheme)
                                            ? `+/- ${newCommonFormatCurrency(
                                                  Math.abs(props.item.totalVatToDeclare),
                                                  undefined,
                                              )}`
                                            : props.item.vatScheme === "Livraison intracom"
                                              ? newCommonFormatCurrency(0, undefined)
                                              : ["Déductible", "Immobilisation"].includes(
                                                      props.item.vatScheme,
                                                  )
                                                ? newCommonFormatCurrency(
                                                      props.item.totalVatToDeclare,
                                                      undefined,
                                                  )
                                                : newCommonFormatCurrency(
                                                      -props.item.totalVatToDeclare,
                                                      undefined,
                                                  )
                                    }}
                                </td>
                                <td>
                                    <v-switch
                                        v-model="props.item.toAdd"
                                        @click.stop
                                        v-if="!componentForAlreadyDeclaredItems"
                                    />
                                    <v-btn-remove-icon
                                        v-else
                                        @click="removeAlreadyDeclaredItem(props.item)"
                                        style="transform: scale(0.75)"
                                    />
                                </td>
                            </tr>
                            <template v-if="props.item.isExpanded">
                                <tr
                                    v-if="
                                        ['Export', 'Non imposable'].includes(props.item.vatScheme)
                                    "
                                    style="background: whitesmoke"
                                >
                                    <td colspan="8">
                                        <v-row no-gutters>
                                            <v-col cols="3" class="text-center">{{
                                                props.item.vatScheme
                                            }}</v-col>
                                            <v-col cols="3" />
                                            <v-col cols="3" class="text-center">
                                                HT :
                                                {{
                                                    newCommonFormatCurrency(
                                                        Math.abs(props.item.totalGrossAmountSigned),
                                                        undefined,
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="3" />
                                        </v-row>
                                    </td>
                                </tr>
                                <template v-else>
                                    <tr
                                        v-for="(detail, index) in props.item.details"
                                        :key="`${props.item.docId}${index}`"
                                        style="background: whitesmoke"
                                    >
                                        <td colspan="8">
                                            <v-row
                                                no-gutters
                                                v-if="props.item.vatScheme === 'Collectée'"
                                            >
                                                <v-col cols="3" class="text-center">
                                                    {{
                                                        !detail.bankDate
                                                            ? `TTC : ${newCommonFormatCurrency(
                                                                  detail.grossAmountSigned,
                                                                  undefined,
                                                              )}`
                                                            : detail.grossAmountSigned > 0
                                                              ? `${newCommonFormatCurrency(
                                                                    detail.grossAmountSigned,
                                                                    undefined,
                                                                )} lettrés le ${detail.bankDate}`
                                                              : `Avoir de ${newCommonFormatCurrency(
                                                                    -detail.grossAmountSigned,
                                                                    undefined,
                                                                )}`
                                                    }}
                                                </v-col>
                                                <v-col cols="9">
                                                    <v-row
                                                        no-gutters
                                                        v-for="(vat, vatIndex) in detail.vats"
                                                        :key="`${props.item.docId}${index}${vatIndex}`"
                                                    >
                                                        <v-col class="text-center" cols="4"
                                                            >{{ getDisplayCollectedVatDetail(vat) }}
                                                        </v-col>
                                                        <v-col class="text-center" cols="4"
                                                            >HT :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    -vat.netAmountSigned,
                                                                    undefined,
                                                                )
                                                            }}</v-col
                                                        >
                                                        <v-col class="text-center" cols="4"
                                                            >TVA :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    -vat.vatAmountSigned,
                                                                    undefined,
                                                                )
                                                            }}</v-col
                                                        >
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <v-container
                                                v-if="
                                                    props.item.vatScheme === 'Z de caisse' &&
                                                    props.item.totalOutputVat
                                                "
                                            >
                                                <v-row no-gutters>
                                                    <v-col cols="3" class="text-center"
                                                        >Déductible sur commission</v-col
                                                    >
                                                    <v-col cols="3" class="text-center">
                                                        TVA :
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    (props.item.totalOutputVat *
                                                                        props.item.grossAmountAls[
                                                                            index
                                                                        ].amountSigned) /
                                                                        props.item
                                                                            .totalGrossAmountSigned,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                    </v-col>
                                                    <v-col cols="3" />
                                                    <v-col cols="3" />
                                                </v-row>
                                            </v-container>
                                            <v-container
                                                v-if="props.item.vatScheme === 'Z de caisse'"
                                            >
                                                <v-row
                                                    no-gutters
                                                    v-for="(vat, vatIndex) in detail.vats"
                                                    :key="`${props.item.docId}${index}${vatIndex}`"
                                                >
                                                    <template v-if="vat.netAmountSigned < 0">
                                                        <v-col cols="3" class="text-center">{{
                                                            vat.rate
                                                                ? "Collectée"
                                                                : "Livraison intracom"
                                                        }}</v-col>
                                                        <v-col class="text-center" cols="3">{{
                                                            vat.rate ? `${vat.rate} %` : ""
                                                        }}</v-col>
                                                        <v-col class="text-center" cols="3">{{
                                                            (vat.rate ? "HT : " : "Base : ") +
                                                            newCommonFormatCurrency(
                                                                Math.abs(vat.netAmountSigned),
                                                                undefined,
                                                            )
                                                        }}</v-col>
                                                        <v-col class="text-center" cols="3"
                                                            >TVA :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    Math.abs(vat.vatAmountSigned),
                                                                    undefined,
                                                                )
                                                            }}</v-col
                                                        >
                                                    </template>
                                                </v-row>
                                            </v-container>
                                            <v-row
                                                no-gutters
                                                v-else-if="
                                                    ['Déductible', 'Immobilisation'].includes(
                                                        props.item.vatScheme,
                                                    )
                                                "
                                            >
                                                <v-col
                                                    v-if="detail.bankDate"
                                                    cols="3"
                                                    class="text-center"
                                                    >{{
                                                        `${newCommonFormatCurrency(
                                                            Math.abs(detail.grossAmountSigned),
                                                            undefined,
                                                        )} payés le ${detail.bankDate} `
                                                    }}</v-col
                                                >
                                                <v-col v-else cols="3"></v-col>
                                                <v-col cols="3" />
                                                <v-col cols="3" />
                                                <v-col
                                                    cols="3"
                                                    class="text-center"
                                                    v-for="(vat, vatIndex) in detail.vats"
                                                    :key="`${props.item.docId}${index}${vatIndex}`"
                                                >
                                                    TVA :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            vat.vatAmountSigned,
                                                            undefined,
                                                        )
                                                    }}
                                                </v-col>
                                            </v-row>
                                            <v-row
                                                no-gutters
                                                v-else-if="
                                                    [
                                                        'Import',
                                                        'Acquisition intracom',
                                                        'Livraison intracom',
                                                        'Autoliquidation',
                                                    ].includes(props.item.vatScheme)
                                                "
                                            >
                                                <v-col cols="3" class="text-center">{{
                                                    props.item.vatScheme
                                                }}</v-col>
                                                <v-col cols="3" />
                                                <v-col class="text-center" cols="3"
                                                    >Base :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                props.item.grossAmountAls[index]
                                                                    .amountSigned,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}</v-col
                                                >
                                                <v-col class="text-center" cols="3">
                                                    TVA :
                                                    {{
                                                        props.item.vatScheme ===
                                                        "Livraison intracom"
                                                            ? newCommonFormatCurrency(0, undefined)
                                                            : newCommonFormatCurrency(
                                                                  detail.vats[0].vatAmountSigned,
                                                                  undefined,
                                                              )
                                                    }}
                                                </v-col>
                                            </v-row>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                    </v-data-table>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";
import { VatItemAuto } from "../../../../../backend/src/common/declaration/declarationServices";

@Component({
    emits: ["remove-already-declared-item"],
})
export class VATDeclarationDetailCardAuto extends Vue {
    @Prop({ default: null }) vatItems: VatItemAuto[];
    @Prop({ default: null }) endDate: string;
    @Prop({ default: true }) fromAutoVATComponent: boolean;
    @Prop({ default: null }) vatAutoType: string;
    @Prop({ default: false }) componentForAlreadyDeclaredItems: boolean;

    selectedVatItemIds: string[] = [];
    lastSelectedIndex: number | null = null;

    showDataTable: boolean = true;

    vatItemsSelectedType: string = "Tout";

    vatItemsStatus: string[] = ["Tout", "A déclarer", "A ne pas déclarer"];

    vatItemsSelectedStatus: string = "Tout";

    get displayableDate() {
        if (this.endDate) {
            return moment(this.endDate).format("DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get disabledVatDeclararionAlreadyDone(): boolean {
        return !this.selectedVatItemIds.length;
    }

    get vatItemsHeaders() {
        const headers = [
            { title: "", value: "checkbox", width: "5%", sortable: false, align: "center" },
            { title: "", value: "", width: "5%", sortable: false, align: "center" },
            { title: "Document", value: "document", width: "40%", align: "start" },
            { title: "Type", value: "vatType", width: "20%", align: "center" },
            { title: "Date", value: "documentDate", width: "5%", align: "center" },
            {
                title: "HT",
                value: "documentNetAmountToDeclare",
                width: "10%",
                align: "center",
            },
            {
                title: "TVA",
                value: "documentVatToDeclare",
                width: "10%",
                align: "center",
            },
            {
                title: this.componentForAlreadyDeclaredItems ? "" : "A déclarer",
                value: "add",
                width: "5%",
                align: "center",
            },
        ];
        return headers;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get title(): string {
        if (this.vatAutoType === "autoValidItems") {
            return "Détail du calcul de la déclaration";
        } else if (this.vatAutoType === "purchasesOnReceiptsNotReconciliated") {
            return "Factures d'achats à l'encaissement non lettrées";
        } else {
            return "Factures d'achat non lettrées"; // assist vat
        }
    }

    get vatItemsTypes(): string[] {
        if (this.vatItems?.length) {
            return [
                "Tout",
                ...Array.from(new Set(this.vatItems.map((vatItem) => vatItem.vatScheme))),
            ];
        }
        return [];
    }

    get filteredVatItems(): VatItemAuto[] {
        if (!this.vatItems?.length) {
            return [];
        }
        return this.vatItems.filter((vatItem) => {
            // filter on types
            const allTypesCondition: boolean = this.vatItemsSelectedType === "Tout";
            const vatSchemeCondition: boolean = vatItem.vatScheme === this.vatItemsSelectedType;
            const exportCondition: boolean =
                this.vatItemsSelectedType === "Export" &&
                vatItem.details.some((detail) =>
                    detail.vats.some((vat) => vat.vatDescription === this.vatItemsSelectedType),
                );
            const nonTaxableCondition: boolean =
                this.vatItemsSelectedType === "Non imposable" &&
                vatItem.details.some((detail) =>
                    detail.vats.some((vat) => vat.rate === 0 && !vat.vatDescription),
                );
            const matchesType: boolean =
                allTypesCondition || vatSchemeCondition || exportCondition || nonTaxableCondition;
            // filter on status
            const matchesStatus: boolean =
                this.vatItemsSelectedStatus === "Tout" ||
                (this.vatItemsSelectedStatus === "A déclarer" && vatItem.toAdd) ||
                (this.vatItemsSelectedStatus !== "A déclarer" && !vatItem.toAdd);
            return matchesType && matchesStatus;
        });
    }

    get selectedVatItems(): VatItemAuto[] {
        return this.vatItems?.filter((item) => this.selectedVatItemIds.includes(item.docId));
    }

    async vatDeclarationAlreadyDone() {
        this.selectedVatItems.forEach((item) => {
            item.isAlreadyDeclared = true;
        });
        this.selectedVatItemIds = [];
    }

    selectAllVatItems() {
        if (this.selectedVatItemIds.length === this.vatItems?.length) {
            this.selectedVatItemIds = [];
        } else {
            this.selectedVatItemIds = this.vatItems?.map((item) => item.docId);
        }
    }

    /**
     * Handles the selection of a vatItem in the list, supporting single and range selection.
     *
     * @param {string} vatId - The ID of the vat to select or deselect.
     * @param {MouseEvent} event - The mouse event triggered by the selection action.
     *
     * This method allows for single selection, multiple selection, and range selection using the Shift key.
     * We can't use Vuetify in-built multiple selections since it would need refactoring for how the component is currently, or refactor to add oss-data-table instead.
     */
    selectVatItem(vatId: string, event: MouseEvent) {
        const index = this.filteredVatItems.findIndex((d) => d.docId === vatId);
        const alreadySelected = this.selectedVatItemIds.includes(vatId);
        if (event.shiftKey && this.lastSelectedIndex !== null) {
            const [start, end] = [this.lastSelectedIndex, index].sort((a, b) => a - b);

            const rangeIds = this.filteredVatItems.slice(start, end + 1).map((d) => d.docId);

            const newSelection = new Set(this.selectedVatItemIds);

            if (alreadySelected) {
                rangeIds.forEach((id) => newSelection.delete(id));
            } else {
                rangeIds.forEach((id) => newSelection.add(id));
            }

            this.selectedVatItemIds = [...newSelection];
        } else {
            // Single selection
            this.selectedVatItemIds = alreadySelected
                ? this.selectedVatItemIds.filter((id) => id !== vatId)
                : [...this.selectedVatItemIds, vatId];

            this.lastSelectedIndex = index;
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getDisplayCollectedVatDetail(vat: any): string {
        if (vat.rate === 0) {
            if (["Export", "Intracom"].includes(vat.vatDescription)) {
                return vat.vatDescription;
            } else if (!vat.vatDescription) {
                return "Non imposable";
            }
        }
        return vat.rate + " %";
    }

    removeAlreadyDeclaredItem(autoItem: VatItemAuto) {
        autoItem.isAlreadyDeclared = false;
    }
}

export default toNative(VATDeclarationDetailCardAuto);
</script>
